import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApplicationTaskModel } from '../../../models/borrower-portal/application-task-model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-website-link-dialog',
    templateUrl: './website-link-dialog.component.html',
    styleUrls: ['./website-link-dialog.component.scss'],
    standalone: false
})
export class WebsiteLinkDialogComponent implements OnInit {

  @Input() applicationId: number;
  @Input() task: ApplicationTaskModel;

  loading = true;
  websiteUrlSafe: SafeResourceUrl | null = null;

  constructor(public activeModal: NgbActiveModal,
    private _sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {

    this.websiteUrlSafe = this._sanitizer.bypassSecurityTrustResourceUrl(this.task.websiteUrl);
  }

  onWebviewLoad(): void {
    this.loading = false;
  }
  onComplete(): void {
    this.activeModal.close();
  }
}
